import {useEffect,useRef,useState} from 'react';
import config from '../../config/config';
import ReactQuill, {Quill} from 'react-quill';
import 'react-quill/dist/quill.snow.css';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Typography from '@mui/material/Typography';
import CustomTextField from './CustomTextField';

const QuillLink = Quill.import("formats/link");

// override default functionality for sanitizing links
const defaultSanitize = QuillLink.sanitize;
QuillLink.sanitize = function customSanitizeLinkInput(linkValueInput) {
    console.log('sanitizing', linkValueInput);
    var val = linkValueInput;
    // do nothing, since this implies user's already using a custom protocol
    if (/^\w+:/.test(val));
    else if (!/^https?:/.test(val)) val = "https://" + val;
    return defaultSanitize.call(this, val); // retain the built-in logic
};

const modules = () => ({
  toolbar: {
    container: [
      ['bold', 'italic', 'underline', 'link'],
      // [{size: ['small', 'medium', 'large', 'huge']}],
      [{'list': 'ordered'}, {'list': 'bullet'}, {'indent': '-1'}, {'indent': '+1'}],
      ['clean']
    ],
  },
  clipboard: {
    matchVisual: false
  },
});

const linkHandler = function (quill, openDialog) {
  return function (value) {
    if (value) {
      openDialog();
    } else {
      quill.format("link", false);
    }
  };
};

const handleChange = ({onChange, setValue}) => value => {
  setValue(value);
  onChange({target: {value}});
};

const handleApplyLink = ({quill, linkURL, setLinkURL, closeDialog}) => e => {
    if (quill && linkURL) {
      quill.format('link', linkURL);
    }
    setLinkURL('');
    closeDialog(false);
};

const HtmlEditor = props => {
  const [value, setValue] = useState(props.defaultValue || '');
  const [linkDialogIsOpen, setLinkDialogIsOpen] = useState(false);
  const [linkURL, setLinkURL] = useState('');
  const quillRef = useRef(null);
  const quillConfig = modules();
  useEffect(() => {
    if (quillRef.current) {
      const quill = quillRef.current.getEditor();
      quill.getModule('toolbar').addHandler('link', linkHandler(quill, () => setLinkDialogIsOpen(true)));
    }
  }, [quillRef]);

  return (
    <Box>
      <Typography variant='body1'>
        <strong>
          {props.label}
        </strong>
      </Typography>
      <Box style={{border: `1px solid ${config().colors.border}`, borderRadius: '3px'}}>
        <ReactQuill
          ref={quillRef}
          theme='snow'
          modules={quillConfig}
          value={value}
          onChange={handleChange({onChange: props.onChange, setValue})}
        />
      </Box>
      <Dialog open={linkDialogIsOpen} onClose={() => setLinkDialogIsOpen(false)}>
        <DialogContent>
          <CustomTextField 
            label='Enter URL:'
            helperText='https://www.example.com'
            onChange={e => setLinkURL(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button 
            onClick={handleApplyLink({
              quill: quillRef?.current?.getEditor(),
              linkURL,
              setLinkURL,
              closeDialog: () => setLinkDialogIsOpen(false),
            })}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default HtmlEditor;
